import { bl_fi_mst_branch_supplier_link_RowClass } from "../../../dbschema/bl_fi_mst_branch_supplier_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class SupplierBranchLinkContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_supplier_link: bl_fi_mst_branch_supplier_link_RowClass =
    new bl_fi_mst_branch_supplier_link_RowClass();
}
